import React from 'react'
import PropTypes from 'prop-types'
import HomeWork from '@mui/icons-material/HomeWork'

const HomeWorkIcon = ({ height, width, ...more }) => {
	
	return (
		<HomeWork
			height={height}
			width={width}
			{...more}
		/>
	)
}

HomeWorkIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default HomeWorkIcon
